import { addEventListener } from 'common/js/media_query_event_polyfill';

class ResponsiveVideo {
  constructor(videoElement) {
    // Elements
    this.videoElement = videoElement;
    this.video = this.videoElement.querySelector('[data-responsive-video-src]');

    // MQL
    this.mql = window.matchMedia('(min-width: 600px)');
    // Init
    this.playVideo();
    this.handleScreenChange();
  }

  playVideo() {
    if (this.mql.matches && this.videoElement) {
      this.video.setAttribute('src', this.video.dataset.responsiveVideoSrc);
      this.videoElement.load();
      this.videoElement.muted = true;
      this.videoElement.play();
    }
  }

  handleScreenChange() {
    if (this.videoElement) {
      addEventListener(this.mql, () => {
        this.video.setAttribute('src', this.video.dataset.responsiveVideoSrc);
        this.videoElement.load();
        this.videoElement.muted = true;
        this.videoElement.play();
      });
    }
  }
}

document.addEventListener('DOMContentLoaded', () => {
  const responsiveVideos = document.querySelectorAll('[data-responsive-video]');

  if (responsiveVideos) {
    responsiveVideos.forEach((responsiveVideo) => {
      new ResponsiveVideo(responsiveVideo);
    });
  }
});
